<template>
  <div class="drawer__header" data-js="get-height">
    <v-layout align-center justify-start>
      <v-btn
        v-if="history.length > 1"
        icon
        @click="goBack"
      >
        <v-icon color="gray-6">keyboard_arrow_left</v-icon>
      </v-btn>

      <v-flex class="drawer__title">{{ $t(`${namespace}.title`) }}</v-flex>
    </v-layout>

    <v-btn icon @click="close()">
      <v-icon color="gray-6">close</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    history: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.voucher.header'
    }
  },
  methods: {
    goBack () {
      this.$emit('goBack')
    },

    close (reload = null) {
      this.$emit('close', reload)
    }
  }
}
</script>
